import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import {
  validAFM,
  validEmail,
  validEmailNotMandatory,
  validGEMI,
  validIban,
  validPercentage,
  validPhoneNumber,
  validWebSite
} from "utils";
import { formFields, formFields1 } from 'pages/mainForms/mainForm/components/terms/formField';

const termFieldNames = [...formFields, ...formFields1]
  .map(it => it.name)
  .filter(it => it !== "termsAll")

// -------------------------------------------------------------------------------------------------
// Validations for mainForm

// WIP. e.g. will see if user is needed etc.
export const validateInvestorApplication = ({ user, formState, isValidCarrierUsers}) => {

  const tab1Validation = validateTab1(formState, isValidCarrierUsers)
  const tab2Validation = validateTab2(formState)
  const tab3Validation = validateTab3(formState)
  const tab4Validation = validateTab4(formState)
  const tab5Validation = validateTab5(formState)
  
  const details = {
    tab1: tab1Validation,
    tab2: tab2Validation,
    tab3: tab3Validation,
    tab4: tab4Validation,
    tab5: tab5Validation
  };
  
  const valid = Object.values(details).every(it => it.valid)

  return {
    valid,
    details,
  }
}

const validateTab1 = (formState, isValidCarrierUsers) => {
  const tab11Validation = validateTab11(formState)
  const tab12Validation = validateTab12(formState, isValidCarrierUsers)

  const details = {
    tab11: tab11Validation,
    tab12: tab12Validation
  }
  const valid = Object.values(details).every(it => it.valid)

  return {
    valid,
    details
  }
}

const validateTab11 = (formState) => {
  const { carrier } = formState
// In the validateTab11 function
console.log('Business size value for validation:', carrier?.businessSize, typeof carrier?.businessSize);
  const details = {
    // Στοιχεία Φορέα Επένδυσης
    abiGcrCode: !carrier?.abiGcrCode || validGEMI(carrier?.abiGcrCode),
    companyName: Boolean(carrier?.companyName),
    legalVat: validAFM(carrier?.legalVat),
    companyLegalType: Boolean(carrier?.companyLegalType),
    // Check gia business size - mono 'Πολύ Μικρή' or 'Μικρή'
    businessSize: Boolean(carrier?.businessSize) && 
    (carrier?.businessSize.includes('Πολύ Μικρή') || carrier?.businessSize.includes('Μικρή')),

    // Διεύθυνση Έδρας Επιχείρησης
    abiDistrict: Boolean(carrier?.abiDistrict),
    buildStreet: Boolean(carrier?.buildStreet),
    buildCity: Boolean(carrier?.buildCity),
    buildTk: Boolean(carrier?.buildTk),
    legalPhoneMobile: validPhoneNumber(carrier?.legalPhoneMobile),
    legalEmail: validEmail(carrier?.legalEmail)
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab12 = (formState, isValidCarrierUsers) => {
  const { carrier } = formState

  const details = {
    // Υπάρχουν άλλοι Εταίροι/Μέτοχοι στον Φορέα της Επένδυσης;
    hasShareholdersFlag: carrier?.hasShareholdersFlag === false ||
    (carrier?.carrierUsers?.every(it => Boolean(
      it.shareholderName &&
      validAFM(it.shareholderVat) &&
      it.shareholderCountry &&
      it.shareholderPercentage &&
      validPercentage(parseFloat((it.shareholderPercentage?.replaceAll(",", ".")))) 
    ))
    && isValidCarrierUsers
    ),
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab2 = (formState) => {
  const { documents, carrier } = formState

  const details = {
    investmentExpenses: Boolean(documents?.investmentExpenses),
    cumulativeDeclaration: Boolean(documents?.cumulativeDeclaration),
    taxFormE3: Boolean(documents?.taxFormE3),
    realBeneficiariesDeclaration: Boolean(documents?.realBeneficiariesDeclaration),
    beneficiariesRegistryPrint: Boolean(carrier.companyLegalType == "Ατομική" || documents?.beneficiariesRegistryPrint),
    gemiCertificate: Boolean(carrier.companyLegalType == "Ατομική" || documents?.gemiCertificate) 
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab3 = (formState) => {
  const tab31Validation = validateTab31(formState)
  const tab32Validation = validateTab32(formState)
  const tab33Validation = validateTab33(formState)

  const details = {
    tab31: tab31Validation,
    tab32: tab32Validation,
    tab33: tab33Validation
  }
  const valid = Object.values(details).every(it => it.valid)

  return {
    valid,
    details
  }
}

const validateTab31 = (formState) => {
  const { carrier } = formState
  const jsonData = carrier?.dapanesEpendysis ? JSON?.parse(carrier?.dapanesEpendysis) : {};
  console.log('carrier:',jsonData);
  const ependutikoSxedio = jsonData?.ependutikoSxedio;
  const toposEkteleshs = jsonData?.toposEkteleshs;
  const details = {
    // Στοιχεία Επενδυτικού Σχεδίου
    titlos: Boolean(ependutikoSxedio?.titlos),
    kwdikosKad: Boolean(ependutikoSxedio?.kwdikosKad),
    enarksh: Boolean(ependutikoSxedio?.enarksh),
    oloklhrwsh: Boolean(ependutikoSxedio?.oloklhrwsh),
    perigrafi: Boolean(ependutikoSxedio?.perigrafi),

    // Χρηματοδοτικά Εργαλεία Επένδυσης
    investmentFinancing: !carrier?.investmentFinancing || Boolean(carrier?.investmentFinancingValue),
    otherInvestmentFinancing: !carrier?.otherInvestmentFinancing || Boolean(carrier?.otherInvestmentFinancingValue),
    // investmentFinancingValue: Boolean(carrier?.investmentFinancingValue),
    // otherInvestmentFinancingValue: Boolean(carrier?.otherInvestmentFinancingValue),

    // Τόπος Εκτέλεσης Επενδυτικού Σχεδίου
    periferia: Boolean(toposEkteleshs?.periferia),
    periferiakiEnotita: Boolean(toposEkteleshs?.periferiakiEnotita),
    dimos: Boolean(toposEkteleshs?.dimos),
    topos: Boolean(toposEkteleshs?.topos),
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab32 = (formState) => {
  const { carrier } = formState

  const details = {
    // TODO
    todo: true
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab33 = (formState) => {
  const { carrier } = formState

  const details = {
    // Στοιχεία Επενδυτικού Σχεδίου
    activityField: Boolean(carrier?.activityField),
    opMonths: carrier?.activityField === "other" || Boolean(carrier?.opMonths),
    roomsNum: carrier?.activityField === "other" || Boolean(carrier?.roomsNum),
    complPerc: carrier?.activityField === "other" || Boolean(carrier?.complPerc && validPercentage(parseFloat(carrier?.complPerc))),
    roomsAvg: carrier?.activityField === "other" || Boolean(carrier?.roomsAvg && carrier.roomsAvg !== "0,00"),
    estQuantity: carrier?.activityField === "tourist" || Boolean(carrier?.estQuantity),
    avgSalePrice: carrier?.activityField === "tourist" || Boolean(carrier?.avgSalePrice && carrier.avgSalePrice !== "0,00"),
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab4 = (formState) => {
  const { carrier } = formState

  const details = {
    // Πιστωτικό Ίδρυμα
    bnkBank: Boolean(carrier?.bnkBank),
    bnkSyndLoan: Boolean(carrier?.bnkSyndLoan)
  }

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}

const validateTab5 = (formState) => {
  const { terms } = formState

  // Terms
  const details = termFieldNames.reduce((acc, name) => {
    acc[name] = Boolean(terms?.[name])
    return acc
  }, {})

  const valid = Object.values(details).every(Boolean)

  return {
    valid,
    details
  }
}
